import axios from "axios";
import { store } from "../store/Store";

const BASEURL = process.env.REACT_APP_UAT_BASE_URL;

const axiosInPosp = axios.create({
  baseURL: BASEURL,
});
axiosInPosp.interceptors.request.use((config) => {
  const auth = store.getState().posp?.Posp;
  console.log("auth", auth);
  const token = auth.accessToken;
  config.headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
  };
  return config;
});

export default axiosInPosp;
